"use strict";

exports.__esModule = true;
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("@mdx-js/react");
/*@jsxRuntime automatic @jsxImportSource react*/

function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    pre: "pre",
    code: "code",
    h2: "h2",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    a: "a",
    blockquote: "blockquote",
    h3: "h3"
  }, (0, _react.useMDXComponents)(), props.components);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_components.h1, {
      id: "gatsby-plugin-theme-ui",
      children: "gatsby-plugin-theme-ui"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Gatsby plugin for adding Theme UI context"
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-sh",
        children: "npm i theme-ui @theme-ui/mdx gatsby-plugin-theme-ui @emotion/react @mdx-js/react\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-js",
        children: "// gatsby-config.js\nmodule.exports = {\n  plugins: ['gatsby-plugin-theme-ui'],\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "In addition to providing context, this plugin will also prevent a flash of\nunstyled colors when using color modes."
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      id: "options",
      children: "Options"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "Key"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Default value"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Description"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "prismPreset"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "null"
            })
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: ["The name of the preset you'd like to use to style code blocks inside your markdown files. The available presets can be found in the ", (0, _jsxRuntime.jsx)(_components.a, {
              href: "https://theme-ui.com/packages/prism/",
              children: "theme-ui docs"
            }), ". You can also use a package string of your own choosing."]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "preset"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "null"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "This can be a JSON theme object or a string package name. Make sure the package you're requiring is installed in your dependencies."
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "injectColorFlashScript"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "true"
            })
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: ["By default, the plugin injects a ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "script"
            }), " tag to prevent color mode flashing. Set this option to ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "false"
            }), " to omit the script. Useful for AMP (Accelerated Mobile Pages) pages."]
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.blockquote, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.p, {
        children: ["Note that this plugin assumes the theme object is exported as ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "default"
        }), "."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "The theme module you include in options is considered your base theme. Any\nfurther customization and shadowing will be merged with it."
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      id: "using-options",
      children: "Using options"
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-js",
        children: "// gatsby-config.js\nmodule.exports = {\n  plugins: [\n    {\n      resolve: 'gatsby-plugin-theme-ui',\n      options: {\n        prismPreset: 'night-owl',\n        preset: '@theme-ui/preset-funk',\n      },\n    },\n  ],\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      id: "customizing-the-theme",
      children: "Customizing the theme"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To customize the theme used in your Gatsby site, shadow the\n", (0, _jsxRuntime.jsx)(_components.code, {
        children: "src/gatsby-plugin-theme-ui/index.js"
      }), " module."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-js",
        filename: "src/gatsby-plugin-theme-ui/index.js",
        children: "const theme = {\n  colors: {\n    text: '#111',\n    background: '#fff',\n  },\n}\n\nexport default theme\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      id: "load-theme-from-custom-path",
      children: "Load theme from custom path"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["If you prefer to load your theme from a custom path (instead of the standard\n", (0, _jsxRuntime.jsx)(_components.code, {
        children: "src/gatsby-plugin-theme-ui/index.js"
      }), "), you can require it in your\n", (0, _jsxRuntime.jsx)(_components.code, {
        children: "gatsby-config.js"
      }), " file:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-js",
        filename: "gatsby-config.js",
        children: "module.exports = {\n  plugins: [\n    {\n      resolve: 'gatsby-plugin-theme-ui',\n      options: {\n        preset: require('./src/theme'),\n      },\n    },\n  ],\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Note that ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "gatsby-config.js"
      }), " does not support ES6 modules, so you should use\n", (0, _jsxRuntime.jsx)(_components.code, {
        children: "module.exports"
      }), " in your theme file:"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-js",
        filename: "src/theme.js",
        children: "module.exports = {\n  colors: {\n    text: '#111',\n    background: '#fff',\n  },\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      id: "extending-a-theme",
      children: "Extending a theme"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "To extend a Gatsby theme that uses Theme UI, import the base theme and export a\nnew theme object."
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-js",
        filename: "src/gatsby-plugin-theme-ui/index.js",
        children: "import baseTheme from 'gatsby-theme-blog/src/gatsby-plugin-theme-ui'\n\nconst theme = {\n  ...baseTheme,\n  colors: {\n    ...baseTheme.colors,\n    text: '#111',\n    background: '#fff',\n  },\n}\n\nexport default theme\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["You can also import and use presets from\n", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://theme-ui.com/packages/presets",
        children: "@theme-ui/presets"
      }), " to use as a starting\npoint."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      id: "color-modes",
      children: "Color Modes"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To enable support for multiple color modes, add a nested ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "modes"
      }), " object to\n", (0, _jsxRuntime.jsx)(_components.code, {
        children: "theme.colors"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-js",
        filename: "src/gatsby-plugin-theme-ui/index.js",
        children: "const theme = {\n  colors: {\n    text: '#000',\n    background: '#fff',\n    modes: {\n      dark: {\n        text: '#fff',\n        background: '#000',\n      },\n    },\n  },\n}\n\nexport default theme\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      id: "components",
      children: "Components"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Custom MDX components that will receive styles from the theme can be included by\nadding a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "src/gatsby-plugin-theme-ui/components.js"
      }), " module."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-js",
        filename: "src/gatsby-plugin-theme-ui/components.js",
        children: "const components = {\n  h1: (props) => (\n    <h1 {...props}>\n      <a href={`#${props.id}`}>{props.children}</a>\n    </h1>\n  ),\n}\n\nexport default components\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "MIT License"
    })]
  });
}
function MDXContent(props = {}) {
  const {
    wrapper: MDXLayout
  } = Object.assign({}, (0, _react.useMDXComponents)(), props.components);
  return MDXLayout ? (0, _jsxRuntime.jsx)(MDXLayout, Object.assign({}, props, {
    children: (0, _jsxRuntime.jsx)(_createMdxContent, props)
  })) : _createMdxContent(props);
}
var _default = exports.default = MDXContent;